<div class="section-gap">
  <div class="create-title create-title-typography">Submit a New Application</div>
  <div class="form-btn-container">
    <ng-container *ngFor="let link of formLinks">
      <button type="button" class="form-btn form-btn-style form-btn-text" [ngClass]="isMobileDeviceSize ? 'form-btn__mobile form-btn-text__mobile' : 'form-btn__full form-btn-text__full'" (click)="createNewApplicationForm(link.formName)">
        <mat-icon class="form-btn-icon" [ngClass]="isMobileDeviceSize ? 'form-btn-icon__mobile' : 'form-btn-icon__full'">{{link.formIcon}}</mat-icon>
          {{ link.formText }}
      </button>
    </ng-container>
  </div>
  <span class="new-app-text" [ngClass]="{ 'new-app-text__full' : !isMobileDeviceSize }">
    Don't know which application to fill out?
    <a href="https://www.ama-assn.org/about/united-states-adopted-names/usan-application-forms" target="_blank" class="new-app-link">Find out here.</a>
  </span>
</div>
